/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const DesktopXLBreakpointIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="DesktopXLBreakpointIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 11H3C2.44772 11 2 10.5523 2 10V2C2 1.44772 2.44772 1 3 1H14C14.5523 1 15 1.44772 15 2V10C15 10.5523 14.5523 11 14 11H11V13H13V14H4V13H6V11ZM3 2H14V10H3L3 2ZM7 11V13H10V11H7Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

DesktopXLBreakpointIcon.tags = [
  'monitor',
  'tv',
  'computer',
  'display',
  'device',
];

DesktopXLBreakpointIcon.category = 'General Icons';

DesktopXLBreakpointIcon.iconSize = 16;
